module.exports = "../dist/img/mini-25.c2af.jpg";